import { Link } from "react-router-dom";
import { Car, Fuel, Gauge } from "lucide-react";
import { Card } from "@/components/ui/card";
import { formatReg } from "@/lib/india";
import { cn } from "@/lib/utils";

const FUEL_COLOR = {
    petrol: "bg-brand-redSoft text-brand-redDeep dark:bg-brand-red/15 dark:text-brand-red/70",
    diesel: "bg-zinc-200 text-zinc-800 dark:bg-zinc-800 dark:text-zinc-200",
    cng: "bg-sky-100 text-sky-800 dark:bg-sky-950/40 dark:text-sky-300",
    lpg: "bg-indigo-100 text-indigo-800 dark:bg-indigo-950/40 dark:text-indigo-300",
    electric: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300",
    hybrid: "bg-violet-100 text-violet-800 dark:bg-violet-950/40 dark:text-violet-300",
};

export function VehicleCard({ vehicle, compact = false }) {
    return (
        <Link to={`/vehicles/${vehicle.id}`} data-testid={`vehicle-card-${vehicle.registration_number}`}>
            <Card className="flex items-start gap-3 p-3 transition-colors hover:border-brand-red/70 dark:hover:border-brand-redDeep">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded border border-zinc-200 bg-zinc-50 text-zinc-600 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300">
                    <Car className="h-4 w-4" />
                </span>
                <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-2">
                        <div className="plate text-sm font-semibold">{formatReg(vehicle.registration_number)}</div>
                        <span
                            className={cn(
                                "rounded px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider",
                                FUEL_COLOR[vehicle.fuel_type] || "bg-zinc-100 text-zinc-700"
                            )}
                        >
                            <Fuel className="mr-1 inline h-3 w-3" />
                            {vehicle.fuel_type}
                        </span>
                    </div>
                    <div className="mt-0.5 truncate text-sm">
                        {vehicle.make} {vehicle.model} {vehicle.variant ? <span className="text-zinc-500">· {vehicle.variant}</span> : null}
                    </div>
                    {!compact && (
                        <div className="mt-1 flex items-center gap-3 font-mono text-[11px] text-zinc-500">
                            <span>{vehicle.year}</span>
                            <span className="flex items-center gap-1">
                                <Gauge className="h-3 w-3" /> {(vehicle.odometer_current ?? 0).toLocaleString()} {vehicle.odometer_unit || "km"}
                            </span>
                        </div>
                    )}
                </div>
            </Card>
        </Link>
    );
}
